import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UVDMServiceService {

  constructor(private httpClient: HttpClient) {
  }

  sourceChannels(): Observable<Array<string>> {
    return this.httpClient.get<Array<string>>(`${environment.baseUrl}/sourceChannels`);
  }
}
